import React from 'react';
import { SvgProp } from './types';

export const OrderedListIcon: React.FC<SvgProp> = ({ width, height, onClick, fill }) => {
  return (
    <svg
      width={width ?? '22'}
      height={height ?? '22'}
      viewBox="0 0 22 22"
      fill={fill ?? 'none'}
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <g clipPath="url(#clip0_92_3920)">
        <path
          d="M3.33725 4.52789V7.064H4.06447V3.69678H3.48392L2.47559 4.37511L2.76281 4.88844L3.33725 4.52789Z"
          fill="black"
        />
        <path
          d="M3.40345 9.05673C3.46642 9.05087 3.52993 9.05793 3.59008 9.07748C3.65023 9.09703 3.70575 9.12866 3.75325 9.17043C3.80074 9.2122 3.8392 9.26323 3.86627 9.32039C3.89334 9.37755 3.90845 9.43964 3.91067 9.50285C3.91067 9.73507 3.78234 9.95507 3.37901 10.279L2.15678 11.2384V11.8495H4.68678V11.1712H3.25678L3.86789 10.7006C4.47901 10.2728 4.65012 9.92451 4.65012 9.4784C4.64495 9.326 4.60868 9.17627 4.54352 9.03841C4.47836 8.90055 4.3857 8.77747 4.27123 8.67673C4.15676 8.576 4.02289 8.49974 3.87787 8.45264C3.73284 8.40554 3.57971 8.38859 3.4279 8.40285C3.17321 8.40137 2.92182 8.46044 2.69444 8.57519C2.46707 8.68994 2.27022 8.85708 2.12012 9.06285L2.58456 9.50896C2.67787 9.37646 2.80008 9.2669 2.94194 9.18856C3.0838 9.11022 3.24161 9.06514 3.40345 9.05673Z"
          fill="black"
        />
        <path
          d="M4.00879 15.0575C4.18227 15.0142 4.33642 14.9144 4.44704 14.774C4.55766 14.6335 4.61846 14.4602 4.6199 14.2814C4.6199 13.7498 4.14324 13.3586 3.39768 13.3586C3.15109 13.3543 2.90685 13.4073 2.68418 13.5133C2.4615 13.6194 2.26645 13.7756 2.11435 13.9698L2.53602 14.4098C2.63361 14.2925 2.75477 14.1971 2.89164 14.1297C3.02851 14.0623 3.17802 14.0245 3.33046 14.0186C3.66046 14.0186 3.89268 14.1775 3.89268 14.422C3.89268 14.6664 3.67268 14.8009 3.28157 14.8009H2.92713V15.412H3.31824C3.77046 15.412 3.97213 15.5403 3.97213 15.797C3.97213 16.0536 3.75824 16.2125 3.36102 16.2125C3.19298 16.2112 3.02702 16.1753 2.8735 16.1069C2.71999 16.0386 2.58222 15.9393 2.46879 15.8153L2.04102 16.292C2.21133 16.4791 2.42038 16.6269 2.65362 16.7251C2.88686 16.8232 3.13868 16.8694 3.39157 16.8603C4.1799 16.8603 4.69324 16.4386 4.69324 15.8581C4.69276 15.6651 4.62363 15.4786 4.49823 15.3319C4.37284 15.1853 4.19934 15.088 4.00879 15.0575Z"
          fill="black"
        />
        <path
          d="M19.8124 5.49978C19.8124 5.33771 19.7481 5.18227 19.6334 5.06766C19.5188 4.95306 19.3634 4.88867 19.2013 4.88867H6.11133V6.11089H19.2013C19.3634 6.11089 19.5188 6.04651 19.6334 5.9319C19.7481 5.8173 19.8124 5.66186 19.8124 5.49978Z"
          fill="black"
        />
        <path
          d="M19.2013 9.77783H6.11133V11.0001H19.2013C19.3634 11.0001 19.5188 10.9357 19.6334 10.8211C19.7481 10.7065 19.8124 10.551 19.8124 10.3889C19.8124 10.2269 19.7481 10.0714 19.6334 9.95682C19.5188 9.84222 19.3634 9.77783 19.2013 9.77783Z"
          fill="black"
        />
        <path
          d="M19.2013 14.667H6.11133V15.8892H19.2013C19.3634 15.8892 19.5188 15.8248 19.6334 15.7102C19.7481 15.5956 19.8124 15.4402 19.8124 15.2781C19.8124 15.116 19.7481 14.9606 19.6334 14.846C19.5188 14.7314 19.3634 14.667 19.2013 14.667Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_92_3920">
          <rect
            width="22"
            height="22"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
